<template>
    <div class="card card--wide" :class="(group.type == 4)?'card--event':'card--news'">
        <router-link :to="{ name: 'view-post', params: { group: group.slug, post: post.slug }}" :class="(post.meta && post.meta.featured_image_contain === true)?'card--contain':''" class="featured-image" :style="'background-image: url(' + post.featured_image + '); background-position: 52% 51% !important;'" v-if="post.featured_image"></router-link>

        <router-link :to="{ name: 'view-post', params: { group: group.slug, post: post.slug }}" class="copy">
            <div class="starts" v-if="group.type == 4 && post.event">{{ formatDate(post.event.starts) }} <span>(in {{ formatDistance(post.event.starts) }})</span></div>
            <h2>{{ post.title }}</h2>
            <p v-if="group.type == 4 && post.event">{{ post.event.venue }}</p>
            <p>{{ post.excerpt || post.dynamic_excerpt }}</p>

            <div v-if="post.published_at">
                <div class="byline">
                    <avatars :users="post.authors" v-if="post.authors"></avatars>
                    <div v-if="group.type != 4">
                        {{ formatDate(post.published_at) }}
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    import { format, formatDistance, parse } from 'date-fns';

    export default {
        props: ['post', 'group', 'contain', 'featured'],
        created() {

        },
        methods: {
            formatDate(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    if(this.group.type == 4){
                        return format(date, 'E do LLL yyyy');
                    }

                    return format(date, 'do LLL yyyy');
                }
            },
            formatDistance(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    return formatDistance(date, new Date());
                }
            }
        }
    }
</script>